import { createContext } from "react";

export const SlidersContext = createContext()
export const SlidersFormContext = createContext()
export const SlidersReportContext = createContext()